export default class TrainingProgram{
    constructor(data){
        this.id=data?.id;
        this.title=data?.title;
    }
}